import {$} from '../util/jq';

const originalContactSubmitted = window.ignite.contactSubmitted;
window.ignite.contactSubmitted = result => {
  const {
    contact: { firstName, lastName, businessName, email, phone} = {}
  } = result;
  const contactName = `${firstName} ${lastName}`;
  const customerInfo = `<div id="clientCustomerInfoText" class="customer-info">
    <span class="tag">Customer Info: </span> 
    <span class="clientName">${contactName}</span>
    <span class="clientEmail">${email}</span>
    <span class="clientPhone">${phone}</span>
  </div>`;
  $('#clientCustomerInfoText').remove();
  $('.summary-content-section').prepend(customerInfo);
  originalContactSubmitted(result);
};

const setupContactMe = () => {
  window.ignite.contactMe = window.ignite.contactMeConsumer;
  window.ignite.getAnswer("businessPostalCode").then(result => {
    if (result.value && result.value[0]) {
      console.log('Business guide detected. Setting up contact form for business');
      window.ignite.contactMe = window.ignite.contactMeBusiness;
    }
  });

  $(document).on('click', '#contactForm .form-body ~ .form-actions', function() {
    $('#contactForm').addClass('showErrors');
  });
};

const openDetails = (summary, activeTrigger) => {
  let activeCard = activeTrigger.parents('.productCell');
  let originalWrapper = $('.original-wrapper');
  let cloneSource = activeTrigger.parents('.productCell').find('> .product-body > .cloneSource');
  let cloneTarget = $('.cloneTarget');
  let screenSize = $(window).width();
  console.log(screenSize);

  // Just move the element without unnecessary cloning
  cloneSource.detach().appendTo(cloneTarget).removeClass('d-none');

  // Setup the collapses
  cloneTarget.find('.collapse').collapse({
    toggle: false
  });

  summary.addClass('detailsActive');
  activeCard.addClass('active');

  setTimeout(function() {
    if (screenSize < 1200) {
      $('html, body').animate({
        scrollTop: 0
      }, 500);

    } else {
      originalWrapper.scroll();

      originalWrapper.animate({
        scrollTop: activeCard.offset().top - 80
      }, 500);
    }
  }, 500);
};

const closeDetails = (summary) => {
  let activeCard = $('.productCell.active');
  let oldClone = $('.card-body.cloneTarget > .cloneSource');
  console.log(oldClone);
  let screenSize = $(window).width();
  console.log(screenSize);

  summary.removeClass('detailsActive');
  activeCard.removeClass('active');

  setTimeout(function() {
    // Just move the element back to its original place without unnecessary destruction
    oldClone.detach().appendTo(activeCard.find('.product-body')).addClass('d-none');

    if (screenSize < 1200) {
      $('html, body').animate({
        scrollTop: activeCard.offset().top - 80
      }, 500);
    }
  }, 500);
};

const setupDetails = () => {
  let summary = $('.summary');

  $('.cloneTrigger').on('click', function(e) {
    e.preventDefault();
    let trigger = $(this);
    let screenSize = $(window).width();
    let delay = (screenSize < 992) ? 500 : 1000;

    if (summary.hasClass('detailsActive')) {
      closeDetails(summary);

      setTimeout(function() {
        openDetails(summary, trigger);
      }, delay);
    } else {
      openDetails(summary, trigger);
    }
  });

  $('.closeTrigger').on('click', function(e) {
    e.preventDefault();
    closeDetails(summary);
  });
};


const setupCheckboxes = () => {
  //Uncheck the followUp (if checked) when checking open today
  $('.checkbox-section.makeReferral label').click(function() {
    const todayIsChecked = $(this).parents('.checkboxes').children('.checkbox-section.makeReferral').find('input').prop('checked');
    const followUpIsChecked = $(this).parents('.checkboxes').children('.checkbox-section.makeReferralLater').find('input').prop('checked');

    if( todayIsChecked && followUpIsChecked ) {
      $(this).parents('.checkboxes').children('.checkbox-section.makeReferralLater').find('input').trigger("click");
    }
  });

  //Vice versa
  $('.checkbox-section.makeReferralLater label').click(function() {
    const todayIsChecked = $(this).parents('.checkboxes').children('.checkbox-section.makeReferral').find('input').prop('checked');
    const followUpIsChecked = $(this).parents('.checkboxes').children('.checkbox-section.makeReferralLater').find('input').prop('checked');

    if( todayIsChecked && followUpIsChecked ) {
      $(this).parents('.checkboxes').children('.checkbox-section.makeReferral').find('input').trigger("click");
    }
  });
};

export default function initSummary() {
  // Prepare the html attributes for fake checkboxes
  $('.fakeCheckbox').removeAttr('for');

  // Setup product details toggling
  setupContactMe();
  setupDetails();
  setupCheckboxes();
}



// WEBPACK FOOTER //
// ./src/main/js/pages/_initSummary.js